var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"stamp",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":require(("@/assets/img/stamp/" + _vm.stampName + ".svg"))}})])}
var staticRenderFns = []

export { render, staticRenderFns }